<div id="progressBar" style="display: flex;" [style.background-color]="bgColor">
    <div *ngFor="let color of colors; let index=index"  style="width: 100%;background-color: transparent;">
        <div class="text-right pr-2"  
            [style.width]="value +'%'" 
            [style.background-color]="colors[index]"
             [style]="border(index,value[index])">
             <span class="text-white font-bold">
                <ng-content></ng-content>
             </span>
        </div>
    </div>
</div>